// Imports
import { mapGetters, mapState } from 'vuex'
import $ from 'jquery'
import L from 'leaflet'
import 'colormap'
import moment from 'moment'
import xml2js from 'xml2js'
import axios from 'axios'

import '@/../node_modules_adapted/leaflet-textpath'
import 'leaflet.antimeridian'
import leafletPolycolor from 'leaflet-polycolor'
// import leafletPolycolor from '@/../node_modules_adapted/leaflet-wrappedpolycolor'
// import 'leaflet-polylinedecorator'
import 'leaflet-rotatedmarker'
// Note: Do not use this plugin to rotate markers as the functionality is already implemented by leaflet-polylinedecorator.
// Importing leaflet-rotatedmarker leads to double rotated markers!
import { Polyline as WrappedPolyline } from 'leaflet.antimeridian/src/vector'

import 'leaflet/dist/leaflet.css'

// Extend polyline to allow coloring
leafletPolycolor(L)

const SECS_PER_MIN = 60

// TODO: Global settings
const NAVIGATION = 1
const OPERATION = 4
const USBL = 13
const LBL = 14
// const TRACKER = 15

const OPACITY_SELECTED = 0.9
const OPACITY_SELECTED_COLORED = 1.0
const OPACITY_DESELECTED = 0.2
const OPACITY_TARGET = 0.6

const OPACITY_USBL = 0.9
const OPACITY_USBL_MAX = 0.9
const OPACITY_USBL_MIN = 0.2
const OPACITY_USBL_DEC = 0.01
const OPACITY_USBL_ACCURACY = 0.1
const OPACITY_USBL_ICON = 0.6

const OPACITY_LBL_ICON = 0.6

const WEIGHT_SELECTED = 3
const WEIGHT_DESELECTED = 2

const INVALID_COORDINATES = { lat: 0, lng: 0 }
const NO_DATA_TRACKCOLOR = 'rgba(204, 204, 204, 0.25)' // '#cccccc'
const TRACK_WIDTH = 3
const TRACK_MISSION_WIDTH = 1
// TODO: Options for use with polyline decorator -> Still issues with international date line
// const TRACK_ARROWHEAD_HEADANGLE = 50
// const TRACK_ARROWHEAD_REPEAT = 150
// const TRACK_ARROWHEAD_SIZE_SELECTED = 7
// const TRACK_ARROWHEAD_SIZE_DESELECTED = 5
// const TRACK_ARROWHEAD_ZOOM_MAX = 12
const RANGE_WIDTH = 2

const ICON_TYPE_PLATFORM = 0
const ICON_TYPE_USBL = 1
const ICON_TYPE_LBL = 2
const ICON_TYPE_TRACKER = 3
const ICON_TYPE_SCHEME = 9

const TARGET_ICON_URL = '/beluga-web/static/icons/checkered-flag.png'
const MISSION_START_ICON_URL = '/beluga-web/static/icons/marker_start.png'
const MISSION_END_ICON_URL = '/beluga-web/static/icons/marker_end.png'
const MAX_USBL_TRACK_LENGTH = 200
const USBL_PING_RADIUS = 3
const USBL_PING_ACCURACY_WEIGHT = 1

const MAX_FEED_ITEM_DESCRIPTION_LENGTH = 500
const PLATFORM_LABEL_OFFSET = 15
const DATA_MARKER_LABEL_OFFSET = -10
const WP_ARRIVAL_DISTANCE = 2

export default {
  name: 'BelugaMapRenderers',
  data: function () {
    return {
      selection: null,
      dataMarker: null
    }
  },
  computed: {
    ...mapState(['platforms', 'selectedPlatform', 'selectedCampaign']),
    ...mapGetters(['currentUpdate', 'lastUpdate', 'campaignSelected', 'updates', 'campaignTimeRange', 'updatesFiltered']),
    position: function () {
      return (platformId, object = false) => {
        return this.shiftPosition(platformId, this.latitude(platformId), this.longitude(platformId),
          this.heading(platformId), this.gpsOffsets(platformId), object)
      }
    },
    target: function () {
      return (platformId, object = false) => {
        const lat = this.latitudeTarget(platformId)
        const lng = this.longitudeTarget(platformId)
        if (lat !== 0 && lng !== 0) {
          // TODO: Shift target position by gps offsets?
          // return this.shiftPosition(platformId, lat, lng,
          //   this.heading(platformId), this.platforms[platformId].gps_offset_x, this.platforms[platformId].gps_offset_y,
          //   object)
        }
        if (object) {
          return { lat: lat, lng: lng }
        }
        return [lat, lng]
      }
    },
    usblPosition: function () {
      return (platformId, object = false) => {
        const lat = this.latitudeUsbl(platformId)
        const lng = this.longitudeUsbl(platformId)
        const accuracy = this.usblAccuracy(platformId)
        let position = [lat, lng, accuracy]
        if (object) {
          position = {
            lat: lat,
            lng: lng,
            accuracy: accuracy
          }
        }
        return position
      }
    },
    lblPosition: function () {
      return (platformId, object = false) => {
        const lat = this.latitudeLbl(platformId)
        const lng = this.longitudeLbl(platformId)
        let position = [lat, lng]
        if (object) {
          position = {
            lat: lat,
            lng: lng
          }
        }
        return position
      }
    },
    usblAccuracy: function () {
      return (platformId) => {
        const update = this.currentUpdate(platformId, USBL, 4)
        return (update.length !== 0) ? Number(update[1]) : null
      }
    },
    latitude: function () {
      return (platformId) => {
        const update = this.currentUpdate(platformId, NAVIGATION, 1)
        return (update.length !== 0) ? Number(update[1]) : 0.0
      }
    },
    longitude: function () {
      return (platformId) => {
        const update = this.currentUpdate(platformId, NAVIGATION, 2)
        return (update.length !== 0) ? Number(update[1]) : 0.0
      }
    },
    latitudeLast: function () {
      return (platformId) => {
        const update = this.lastUpdate(platformId, NAVIGATION, 1)
        return (update.length !== 0) ? Number(update[1]) : 0.0
      }
    },
    longitudeLast: function () {
      return (platformId) => {
        const update = this.lastUpdate(platformId, NAVIGATION, 2)
        return (update.length !== 0) ? Number(update[1]) : 0.0
      }
    },
    latitudeUsbl: function () {
      return (platformId) => {
        const update = this.currentUpdate(platformId, USBL, 1)
        return (update.length !== 0) ? Number(update[1]) : 0.0
      }
    },
    longitudeUsbl: function () {
      return (platformId) => {
        const update = this.currentUpdate(platformId, USBL, 2)
        return (update.length !== 0) ? Number(update[1]) : 0.0
      }
    },
    latitudeLbl: function () {
      return (platformId) => {
        const update = this.currentUpdate(platformId, LBL, 1)
        return (update.length !== 0) ? Number(update[1]) : 0.0
      }
    },
    longitudeLbl: function () {
      return (platformId) => {
        const update = this.currentUpdate(platformId, LBL, 2)
        return (update.length !== 0) ? Number(update[1]) : 0.0
      }
    },
    latitudeTarget: function () {
      return (platformId) => {
        const update = this.currentUpdate(platformId, OPERATION, 4)
        return (update.length !== 0) ? Number(update[1]) : 0.0
      }
    },
    longitudeTarget: function () {
      return (platformId) => {
        const update = this.currentUpdate(platformId, OPERATION, 5)
        return (update.length !== 0) ? Number(update[1]) : 0.0
      }
    },
    captainState: function () {
      return (platformId) => {
        const update = this.currentUpdate(platformId, 4, 6)
        return (update.length !== 0) ? Number(update[1]) : 0
      }
    },
    track: function () {
      return (platformId) => {
        // Check if track needs to be recalculated
        const lats = this.updates(platformId, NAVIGATION, 1)
        let trackLength = 0
        if ('tracks' in this.platforms[platformId].cache) {
          trackLength = this.platforms[platformId].cache.tracks.nav.length
        }
        const newPositionsCount = lats.length - trackLength
        if (newPositionsCount > 0) {
          console.debug('map renderer: calculating ' + newPositionsCount + ' new track sections of platform ' + platformId)
          // Get new longitudes
          const lngs = this.updates(platformId, NAVIGATION, 2)
          if (lats.length === lngs.length) {
            const headings = this.updates(platformId, NAVIGATION, 3)
            const newLngs = lngs.slice(-newPositionsCount)
            // Only recalculate new sections of track
            let newShiftedPositions = lats.slice(-newPositionsCount).map((row, i) => {
              // Only shift position if offset distance is greater zero
              if (this.compareCoordinates({ lat: Number(row[1]), lng: Number(newLngs[i][1]) }, INVALID_COORDINATES)) {
                return false
              }
              if (this.gpsOffsets(platformId)[0] > 0) {
                let heading
                if (headings.length > 0 && newPositionsCount > 1) {
                  heading = this.getClosestValue(row[0], headings)[1]
                } else {
                  heading = this.heading(platformId)
                }
                // Shift every new position on track
                const shiftedPos = this.shiftPosition(platformId, Number(row[1]), Number(newLngs[i][1]), heading,
                  this.gpsOffsets(platformId), true)
                return { lat: Number(shiftedPos.lat), lng: Number(shiftedPos.lng), ts: Number(row[0]) }
              }
              return { lat: Number(row[1]), lng: Number(newLngs[i][1]), ts: Number(row[0]) }
            })
            // Return merged positions (old track + new calculated sections)
            newShiftedPositions = newShiftedPositions.filter(function (pos) {
              return pos !== false
            })
            this.platforms[platformId].cache.tracks.nav.push(...newShiftedPositions)
          } else {
            console.warn('map renderer: platform ' + platformId + ' track is broken! lats: ' + lats.length + ' - lngs: ' + lngs.length)
          }
        }
        return this.platforms[platformId].cache.tracks.nav
      }
    },
    heading: function () {
      return (platformId) => {
        const update = this.currentUpdate(platformId, NAVIGATION, 3)
        return (update.length !== 0) ? Number(update[1]) : 0
      }
    },
    speed: function () {
      return (platformId) => {
        const update = this.currentUpdate(platformId, NAVIGATION, 6)
        return (update.length !== 0) ? Number(update[1]) : 0.0
      }
    },
    gpsOffsets: function () {
      return (platformId) => {
        const gpsX = Number(this.platforms[platformId].gps_offset_x / 1000)
        const gpsY = Number(this.platforms[platformId].gps_offset_y / 1000)
        return [Math.sqrt(Math.pow(gpsX, 2) + Math.pow(gpsY, 2)), (Math.atan2(gpsY, gpsX) / Math.PI * 180)]
      }
    },
    usblOffsets: function () {
      return (platformId) => {
        const usblX = Number(this.platforms[platformId].usbl_offset_x / 1000)
        const usblY = Number(this.platforms[platformId].usbl_offset_y / 1000)
        return [Math.sqrt(Math.pow(usblX, 2) + Math.pow(usblY, 2)), (Math.atan2(usblY, usblX) / Math.PI * 180)]
      }
    },
    parameterMetaData: function () {
      return (parameter) => {
        if (parameter !== null) {
          return this.parameter(parameter[0], parameter[1], parameter[2])
        }
        return {
          unit: '',
          label: '',
          precision: 2
        }
      }
    }
  },
  methods: {
    getAge: function (timestamp, skip) {
      // TODO: Helpers?
      if (timestamp > 0) {
        return moment.unix(timestamp).fromNow(skip)
      } else {
        return 'never'
      }
    },
    shiftPosition: function (platformId, latitude, longitude, heading, offsets, object = false) {
      let position
      if (offsets[0] !== 0) {
        const correctedHdg = (heading + offsets[1]) + 180 % 360
        position = this.getDestination([latitude, longitude], correctedHdg, offsets[0])
      } else {
        position = [latitude, longitude]
      }
      if (object) {
        return { lat: position[0], lng: position[1] }
      }
      return position
    },
    meterInPixels: function (widget) {
      return 40075016.686 * Math.abs(Math.cos(widget.map.getCenter().lat * Math.PI / 180)) / Math.pow(2, widget.map.getZoom() + 8)
    },
    getTargetEta: function (widget, position, target, speed) {
      if (!widget.compareCoordinates(position, INVALID_COORDINATES) &&
        !widget.compareCoordinates(target, INVALID_COORDINATES) && speed > 0) {
        const distance = widget.getDistance(position, target)
        if (distance > WP_ARRIVAL_DISTANCE) {
          const seconds = distance / speed
          const minutes = widget.roundDigits(seconds / SECS_PER_MIN, 0)
          if (minutes > 1) {
            return minutes + ' min (' + moment().add(seconds, 'seconds').format('HH:mm') + ')'
          } else {
            return '< 1 min'
          }
        }
      }
      return null
    },
    lazyLoadPlatformIcon: function (widget, marker, platform, iconUrl = platform.icon_url, type = ICON_TYPE_PLATFORM) {
      // Lazy load icon image in the background
      // Handle class name based on icon typ
      // TODO: Implement a more generic approach
      let className = 'platform-icon-'
      switch (type) {
        case ICON_TYPE_USBL:
          className = 'platform-ghost-usbl-'
          break
        case ICON_TYPE_LBL:
          className = 'platform-ghost-lbl-'
          break
        case ICON_TYPE_TRACKER:
          className = 'platform-ghost-tracker-'
          break
        case ICON_TYPE_SCHEME:
          className = 'platform-scheme-'
          break
        default:
      }
      const scaleFactor = (type === ICON_TYPE_SCHEME) ? this.meterInPixels(widget) : 1
      const iconImg = new Image()
      iconImg.onload = () => {
        let width = iconImg.width
        let height = iconImg.height
        if (type === ICON_TYPE_SCHEME) {
          width = platform.width / scaleFactor
          height = platform.length / scaleFactor
        }
        const icon = new L.Icon({
          iconUrl: iconUrl,
          iconSize: [width, height],
          iconAnchor: (type === ICON_TYPE_SCHEME) ? [width / 2, height / 2] : [width / 2, height / 2 + 5],
          popupAnchor: [0, -iconImg.height],
          className: className + platform.id
        })
        // Set icon
        marker.setIcon(icon)
        widget.handlePlatformMarkers(widget, platform.id)
      }
      iconImg.onerror = () => {
        console.error('map renderer: icon (' + iconImg.src + ') of platform ' + platform.id + ' not found')
      }
      iconImg.src = iconUrl // Actually load image
    },
    createFeedItemPopup: function (item) {
      let description = ''
      if (typeof item.description !== 'undefined') {
        if (item.description.length > MAX_FEED_ITEM_DESCRIPTION_LENGTH) {
          description = item.description.substr(0, MAX_FEED_ITEM_DESCRIPTION_LENGTH) + '...'
        } else {
          description = item.description
        }
      }
      let footer = ''
      if ('link' in item) {
        footer = '<a href="' + item.link + '" target="_blank"><b>Read more &neArr;</b></a>'
      }
      if ('media' in item) {
        if (item.media.type === 'audio/mpeg') {
          footer = '<audio controls src="' + item.media.url + '" type="audio/mpeg" class="mt-2"></audio>'
        }
      }
      return '<h6><b>' + item.title + '</b></h6>' +
        '<span>' + description + '</span> ' +
        footer
    },
    createSelectionIcon: function (widget, platformId) {
      const platform = widget.platforms[platformId]
      const svg = '<?xml version="1.0" standalone="no"?>\n' +
        '<svg width="100" height="100" version="1.1" xmlns="http://www.w3.org/2000/svg">\n' +
        '  <!--<rect x="0" y="0" width="100" height="100" fill="#ffffff" fill-opacity="0.4"/>-->' +
        '  <polyline stroke-linecap="round" stroke-opacity="1.0" points="0 30 0 0 30 0"\n stroke="' + platform.color + '" fill="transparent" stroke-width="10"/>\n' +
        '  <polyline stroke-linecap="round" stroke-opacity="1.0" points="70 0 100 0 100 30"\n stroke="' + platform.color + '" fill="transparent" stroke-width="10"/>\n' +
        '  <polyline stroke-linecap="round" stroke-opacity="1.0" points="100 70 100 100 70 100"\n stroke="' + platform.color + '" fill="transparent" stroke-width="10"/>\n' +
        '  <polyline stroke-linecap="round" stroke-opacity="1.0" points="0 70 0 100 30 100"\n stroke="' + platform.color + '" fill="transparent" stroke-width="10"/>\n' +
        '</svg>'
      return new L.DivIcon({
        html: svg,
        iconSize: [100, 100],
        iconAnchor: [50, 50],
        className: 'selection-icon'
      })
    },
    createHeadingIcon: function (widget, platformId) {
      const platform = widget.platforms[platformId]
      const svg = '<?xml version="1.0" standalone="no"?>\n' +
        '<svg width="15" height="40" version="1.1" xmlns="http://www.w3.org/2000/svg">\n' +
        '  <polygon stroke-linecap="round" stroke-opacity="1.0" points="0,15 8,0 15,15 8,10 0,15" ' +
        '   stroke="#ffffff" fill="' + platform.color + '" stroke-width="2"/>\n' +
        '</svg>'
      return new L.DivIcon({
        html: svg,
        iconSize: [15, 40],
        iconAnchor: [8, 40],
        className: 'heading-icon-' + platformId
      })
    },
    addPlatform: function (widget, platformId) {
      // Set up map objects
      if (platformId in this.platforms && !('map' in this.platforms[platformId])) {
        console.debug('map renderer: setting up platform ' + platformId)
        const platform = this.platforms[platformId]
        // Create past track
        const latLngs = []

        // Create data cache (for performance track operations)
        platform.cache = {
          tracks: {
            nav: [],
            data: []
          }
        }
        // Create map objects
        platform.map = {
          markers: {},
          tracks: {},
          decorators: {},
          headings: {},
          target: {
            marker: null,
            circle: null,
            line: null
          },
          mission: {
            track: null,
            markers: {}
          },
          usbl: {
            markers: [],
            accuracy: null
          },
          lbl: {
            marker: null
          },
          tracker: {
            marker: null
          }
        }
        // Add markers
        platform.map.markers = {
          icon: L.marker(this.position(platformId), {
            title: platform.description,
            zIndexOffset: (platform.type.startsWith('ship')) ? 1000 : 1100,
            tooltipAnchor: [0, 0]
          }),
          scheme: L.marker(this.position(platformId), {
            zIndexOffset: (platform.type.startsWith('ship')) ? 500 : 600,
            rotationOrigin: 'center',
            rotationAngle: this.heading(platformId),
            tooltipAnchor: [0, 0]
          })
        }
        // Bind tooltips to markers
        platform.map.markers.icon.bindTooltip(platform.description, {
          className: 'transparent-tooltip transparent-tooltip-' + platform.id,
          direction: 'bottom',
          offset: [0, PLATFORM_LABEL_OFFSET],
          permanent: true,
          opacity: 1.0
        })
        platform.map.markers.scheme.bindTooltip(platform.description, {
          className: 'solid-tooltip solid-tooltip-' + platform.id,
          direction: 'center',
          offset: [0, 0],
          permanent: false,
          opacity: 1.0
        })
        // Add callback handlers to markers
        platform.map.markers.icon.on('click', () => {
          // Commit selection of platform to global data model
          this.select_platform(platform.id)
        })
        platform.map.markers.scheme.on('click', () => {
          // Commit selection of platform to global data model
          this.select_platform(platform.id)
        })
        // Add icons to markers
        this.lazyLoadPlatformIcon(widget, platform.map.markers.icon, platform, platform.icon_url)
        this.lazyLoadPlatformIcon(widget, platform.map.markers.scheme, platform, platform.scheme_url, ICON_TYPE_SCHEME)

        // USBL/LBL/tracker visualization marker
        if (platform.type === 'auv-g500' || platform.type === 'transponder' || platform.type === 'lander') {
          // USBL
          platform.map.markers.ghost_usbl = L.marker(this.usblPosition(platformId), {
            title: platform.description + ' (USBL)',
            zIndexOffset: 950,
            tooltipAnchor: [0, 0],
            opacity: OPACITY_USBL_ICON
          })
          this.lazyLoadPlatformIcon(widget, platform.map.markers.ghost_usbl, platform, platform.icon_url, ICON_TYPE_USBL)
          platform.map.markers.ghost_usbl.bindTooltip(platform.name + ' (USBL)', {
            className: 'transparent-tooltip transparent-tooltip-' + platform.id,
            direction: 'bottom',
            offset: [0, PLATFORM_LABEL_OFFSET],
            permanent: false,
            opacity: OPACITY_USBL_ICON
          })
          if (platform.type === 'auv-g500') {
            // LBL
            platform.map.markers.ghost_lbl = L.marker(this.lblPosition(platformId), {
              title: platform.description + ' (LBL)',
              zIndexOffset: 950,
              tooltipAnchor: [0, 0],
              opacity: OPACITY_LBL_ICON
            })
            this.lazyLoadPlatformIcon(widget, platform.map.markers.ghost_lbl, platform, platform.icon_url, ICON_TYPE_LBL)
            platform.map.markers.ghost_lbl.bindTooltip(platform.name + ' (LBL)', {
              className: 'transparent-tooltip transparent-tooltip-' + platform.id,
              direction: 'bottom',
              offset: [0, PLATFORM_LABEL_OFFSET],
              permanent: false,
              opacity: OPACITY_LBL_ICON
            })
          }
        }

        if (platform.type !== 'transponder' && platform.type !== 'lander' && platform.type !== 'sonde') {
          // Add tracks
          let opacity = OPACITY_DESELECTED
          let weight = WEIGHT_DESELECTED
          // let arrowHeadSize = TRACK_ARROWHEAD_SIZE_DESELECTED

          if (Number(platformId) === Number(widget.selectedPlatform)) {
            opacity = OPACITY_SELECTED
            // arrowHeadSize = TRACK_ARROWHEAD_SIZE_SELECTED
            weight = WEIGHT_SELECTED
          }
          platform.map.tracks = {
            nav: new WrappedPolyline(latLngs, {
              color: platform.color,
              weight: weight,
              opacity: opacity,
              interactive: false
            })
          }
          // TODO: Polyline decorator (arrows) is not compatible with antimeridian plugin (international date line)
          // if (platform.type !== 'buoy' && platform.type !== 'mooring') {
          //   // Add track decorator
          //   platform.map.decorators.nav = L.polylineDecorator(platform.map.tracks.nav, {
          //     patterns: [
          //       {
          //         repeat: TRACK_ARROWHEAD_REPEAT,
          //         symbol: L.Symbol.arrowHead({
          //           headAngle: TRACK_ARROWHEAD_HEADANGLE,
          //           pixelSize: arrowHeadSize,
          //           pathOptions: {
          //             color: platform.map.tracks.nav.options.color,
          //             opacity: platform.map.tracks.nav.options.opacity
          //           }
          //         })
          //       }
          //     ]
          //   })
          // }
          // FIXME: Dynamic
          if (platform.type !== 'mooring' &&
            platform.type !== 'argo-float' &&
            platform.type !== 'drifter' &&
            platform.type !== 'buoy' &&
            platform.type !== 'ship-nohead' &&
            platform.type !== 'ship-eugenseibold' &&
            platform.type !== 'sonde' &&
            !platform.type.startsWith('logger')) { // TODO true for all loggers?
            // Add headings
            platform.map.headings = {
              nav: L.marker(this.position(platformId), {
                icon: this.createHeadingIcon(widget, platformId),
                rotationOrigin: 'bottom center',
                rotationAngle: this.heading(platformId)
              })
            }
          }
        }

        // Handle initial visibility
        if (this.campaignSelected.platforms.includes(platformId)) {
          this.showPlatform(widget, platformId)
        }

        // DEBUG: Load mission
        this.loadMission(platformId)
      }
    },
    addMediaFeed: function (widget, campaignId) {
      if (campaignId in widget.campaigns && 'project_feed_data' in widget.campaigns[campaignId] &&
        !('map' in widget.campaigns[campaignId])) {
        const campaign = widget.campaigns[campaignId]
        console.log('map renderer: setting up feed overlay of campaign "' + campaign.name + '"')
        campaign.map = {
          feed_items: {}
        }
        campaign.project_feed_data.channel.items.forEach(item => {
          if (!this.compareCoordinates(item.position, INVALID_COORDINATES)) {
            const marker = L.marker(item.position, {
              icon: L.icon({
                iconUrl: '/beluga-web/static/icons/speech_bubble_comment.png', // TODO: Different icons
                iconSize: [24, 24],
                iconAnchor: [7, 22],
                popupAnchor: [0, -24]
              })
            })
            // Add popup
            marker.bindPopup(this.createFeedItemPopup(item))
            marker.bindTooltip(item.title, {
              direction: 'bottom',
              className: 'feed-tooltip'
            })
            // Add click callback
            marker.on('click', () => {
              widget.select_feed_item(item.index)
            })
            // If campaign is selected and marker is not yet rendered: Add to map
            if (campaignId === this.selectedCampaign && !widget.map.hasLayer(marker)) {
              widget.map.addLayer(marker)
            }
            // Add marker to campaign
            campaign.map.feed_items[item.index] = marker
          }
        })
      }
    },
    renderMediaFeed: function (widget, campaignId) {
      if (campaignId in widget.campaigns && ('map' in widget.campaigns[campaignId]) && ('feed_items' in widget.campaigns[campaignId].map)) {
        const campaign = widget.campaigns[campaignId]
        console.log('map renderer: rendering feed overlay of campaign "' + campaign.name + '"')
        for (const itemId in campaign.map.feed_items) {
          widget.map.addLayer(campaign.map.feed_items[itemId])
        }
      }
    },
    removeMediaFeed: function (widget, campaignId) {
      if (campaignId in widget.campaigns && ('map' in widget.campaigns[campaignId]) && ('feed_items' in widget.campaigns[campaignId].map)) {
        const campaign = widget.campaigns[campaignId]
        console.log('map renderer: removing feed overlay of campaign "' + campaign.name + '"')
        for (const itemId in campaign.map.feed_items) {
          widget.map.removeLayer(campaign.map.feed_items[itemId])
        }
      }
    },
    renderPlatform: function (widget, platformId) {
      console.debug('map renderer: updating platform ' + platformId + ', rendering new data')
      if (platformId in this.platforms) {
        const platform = this.platforms[platformId]
        // Call child renderers
        if (this.renderPlatformMarkers(widget, platform)) {
          this.renderPlatformUsblTrack(widget, platform)
          if (platform.type !== 'transponder' && platform.type !== 'lander' && platform.type !== 'sonde') {
            this.renderPlatformTracks(widget, platform)
            this.renderPlatformTarget(widget, platform)
            if (platform.type !== 'mooring' &&
              platform.type !== 'argo-float' &&
              platform.type !== 'drifter' &&
              platform.type !== 'buoy' &&
              platform.type !== 'ship-nohead' &&
              platform.type !== 'ship-eugenseibold' &&
              platform.type !== 'glider-nohead' &&
              platform.type !== 'ship-tor' &&
              platform.type !== 'sonde' &&
              !platform.type.startsWith('logger')) { // TODO true for all loggers?
              this.renderPlatformHeadings(widget, platform)
            }
          }
          // Handle selection
          if (this.selectedPlatform === Number(platformId)) {
            this.renderPlatformSelection(widget, platformId)
            if ((widget.options.lockMap || widget.options.initialCentered === false) &&
              !this.compareCoordinates(this.position(platformId, true), INVALID_COORDINATES)) {
              this.centerPlatform(widget, platformId)
            }
          }
          // Render ranging tool if active
          this.renderRangingTool(widget)
          // Handle zoom level
          this.handlePlatformMarkers(widget, platformId)
        }
      }
    },
    renderPlatformMarkers: function (widget, platform) {
      const position = this.position(platform.id, true)
      if (!this.compareCoordinates(position, INVALID_COORDINATES)) {
        const heading = this.heading(platform.id)
        // Update icon marker
        platform.map.markers.icon.setLatLng(position)
        // Flip platform label based on heading
        // TODO: Check if heading is actually available
        if (heading >= 90 && heading <= 270) {
          platform.map.markers.icon.getTooltip().options.offset = [0, -PLATFORM_LABEL_OFFSET]
          platform.map.markers.icon.getTooltip().options.direction = 'top'
        } else {
          platform.map.markers.icon.getTooltip().options.offset = [0, PLATFORM_LABEL_OFFSET]
          platform.map.markers.icon.getTooltip().options.direction = 'bottom'
        }
        if ('ghost_usbl' in platform.map.markers) {
          // Update icon marker
          platform.map.markers.ghost_usbl.setLatLng(this.usblPosition(platform.id, true))
          // Flip platform label based on heading
          // TODO: Check if heading is actually available
          if (heading >= 90 && heading <= 270) {
            platform.map.markers.ghost_usbl.getTooltip().options.offset = [0, -PLATFORM_LABEL_OFFSET]
            platform.map.markers.ghost_usbl.getTooltip().options.direction = 'top'
          } else {
            platform.map.markers.ghost_usbl.getTooltip().options.offset = [0, PLATFORM_LABEL_OFFSET]
            platform.map.markers.ghost_usbl.getTooltip().options.direction = 'bottom'
          }
        }
        if ('ghost_lbl' in platform.map.markers) {
          // Update icon marker
          platform.map.markers.ghost_lbl.setLatLng(this.lblPosition(platform.id, true))
          // Flip platform label based on heading
          // TODO: Check if heading is actually available
          if (heading >= 90 && heading <= 270) {
            platform.map.markers.ghost_lbl.getTooltip().options.offset = [0, -PLATFORM_LABEL_OFFSET]
            platform.map.markers.ghost_lbl.getTooltip().options.direction = 'top'
          } else {
            platform.map.markers.ghost_lbl.getTooltip().options.offset = [0, PLATFORM_LABEL_OFFSET]
            platform.map.markers.ghost_lbl.getTooltip().options.direction = 'bottom'
          }
        }
        // Update scheme marker
        platform.map.markers.scheme.setLatLng(position)
        platform.map.markers.scheme.setRotationAngle(heading)

        // Update selection marker if required
        if (widget.selection != null && widget.selectedPlatform === platform.id) {
          widget.selection.setLatLng(position)
        }
        // TODO: Target marker
        return true
      } else {
        return false
      }
    },
    renderPlatformHeadings: function (widget, platform) {
      const position = this.position(platform.id, true)
      if (!this.compareCoordinates(position, INVALID_COORDINATES)) {
        platform.map.headings.nav.setLatLng(position)
        platform.map.headings.nav.setRotationAngle(this.heading(platform.id))
        // Flip platform label based on heading
        if (this.heading(platform.id) >= 90 && this.heading(platform.id) <= 270) {
          platform.map.markers.icon.getTooltip().options.offset = [0, -PLATFORM_LABEL_OFFSET]
          platform.map.markers.icon.getTooltip().options.direction = 'top'
        } else {
          platform.map.markers.icon.getTooltip().options.offset = [0, PLATFORM_LABEL_OFFSET]
          platform.map.markers.icon.getTooltip().options.direction = 'bottom'
        }
      }
    },
    renderPlatformTracks: function (widget, platform) {
      // Render platform track
      const track = this.track(platform.id)
      const mapTrack = platform.map.tracks.nav.getLatLngs()
      // Add all new positions to track
      const diff = track.length - mapTrack.length
      if (diff > 1 || diff < 1) {
        platform.map.tracks.nav.setLatLngs(track)
      } else if (diff === 1) {
        platform.map.tracks.nav.addLatLng(track[track.length - 1])
      }
      platform.map.tracks.nav.bringToFront()
      // Update track decorators
      // if ('nav' in platform.map.decorators) {
      //   platform.map.decorators.nav.setPaths(platform.map.tracks.nav)
      // }
      console.debug('map renderer: added ' + diff + ' position(s) to track of "' + platform.name + '" (' + platform.id + ')')
    },
    renderPlatformUsblTrack: function (widget, platform) {
      // Render USBL track (if available)
      const usblPosition = this.usblPosition(platform.id, true)
      if (!this.compareCoordinates(usblPosition, INVALID_COORDINATES) && usblPosition.accuracy !== null) {
        const usblTrack = platform.map.usbl.markers
        // If track not exists: Create track
        if (usblTrack.length === 0 || !(this.compareCoordinates(usblPosition, usblTrack[usblTrack.length - 1].getLatLng()))) {
          // Adapt opacities of previous markers based on track length
          const opacityMax = OPACITY_USBL_MAX
          const opacityMin = OPACITY_USBL_MIN
          const opacityDec = OPACITY_USBL_DEC
          let opacity = opacityMax
          for (let i = usblTrack.length - 1; i >= 0; i--) {
            usblTrack[i].setStyle({
              fillOpacity: opacity
            })
            if (opacity > opacityMin) {
              opacity = opacity - opacityDec
            } else {
              opacity = opacityMin
            }
          }
          // Remove the oldest ping if necessary
          if (usblTrack.length >= MAX_USBL_TRACK_LENGTH) {
            widget.map.removeLayer(usblTrack[0])
            usblTrack.shift()
          }
          // Add new (fixed-radius) USBL ping
          usblTrack.push(new L.CircleMarker(usblPosition, {
            fill: true,
            fillColor: platform.color,
            fillOpacity: OPACITY_USBL,
            stroke: false,
            radius: USBL_PING_RADIUS
          }).addTo(widget.map))

          // Show USBL accuracy
          let radius = this.roundDigits(Number(usblPosition.accuracy) / 2, 1)
          // FIXME: Workaround, Leaflet draws ellipses if radius below 0.4 meters
          if (radius < 0.4) {
            radius = 0.4
          }
          if (platform.map.usbl.accuracy !== null) {
            // Update existing accuracy marker, adapt position and radius
            platform.map.usbl.accuracy.setLatLng(usblPosition)
            platform.map.usbl.accuracy.setRadius(radius)
          } else {
            // Add new accuracy circle
            platform.map.usbl.accuracy = new L.Circle(usblPosition, {
              fill: true,
              fillColor: platform.color,
              fillOpacity: OPACITY_USBL_ACCURACY,
              stroke: true,
              color: platform.color,
              weight: USBL_PING_ACCURACY_WEIGHT,
              radius: radius
            }).addTo(widget.map)
          }
        }
        console.debug('map renderer: added usbl position(s) to "' + platform.name + '" (' + platform.id + ')')
      }
    },
    renderPlatformTarget: function (widget, platform) {
      const position = this.position(platform.id, true)
      const target = this.target(platform.id, true)
      const speed = this.speed(platform.id) // Need to be in m/s!
      const eta = this.getTargetEta(widget, position, target, speed)
      const captainState = this.captainState(platform.id)
      if (!this.compareCoordinates(target, INVALID_COORDINATES)) {
        if (platform.map.target.marker === null) {
          // Create target marker
          platform.map.target.marker = new L.Marker(target, {
            title: 'Target of ' + platform.description,
            icon: new L.Icon({
              iconUrl: TARGET_ICON_URL,
              iconSize: [24, 24],
              iconAnchor: [4, 21],
              popupAnchor: [0, -24]
            })
          }).addTo(widget.map)
          // Colored marker circle
          platform.map.target.circle = new L.Circle(target, {
            fill: true,
            fillOpacity: 0.25,
            stroke: true,
            weight: (captainState === 3 || captainState === 4) ? 3 : 1,
            color: (captainState === 3 || captainState === 4) ? '#ffc107' : platform.color,
            fillColor: (captainState === 3 || captainState === 4) ? '#ffc107' : platform.color,
            radius: 2 // TODO: Arrival distance
          }).addTo(widget.map)
        } else {
          const oldTargetPos = platform.map.target.marker.getLatLng()
          if (!this.compareCoordinates(target, oldTargetPos)) {
            // Update target markers if coordinates have changed
            platform.map.target.marker.setLatLng(target)
            platform.map.target.circle.setLatLng(target)
          }
          // Always adapt color and weight of target circle (Safety / default)
          platform.map.target.circle.setStyle({
            weight: (captainState === 3 || captainState === 4) ? 3 : 1,
            color: (captainState === 3 || captainState === 4) ? '#ffc107' : platform.color,
            fillColor: (captainState === 3 || captainState === 4) ? '#ffc107' : platform.color
          })
        }
        // Handle ETA
        if (eta !== null) {
          if (platform.map.target.marker.getTooltip() == null) {
            // Bind tooltip if ETA can be calculated
            platform.map.target.marker.bindTooltip(eta, {
              className: 'solid-tooltip',
              direction: 'top',
              offset: [1, -20],
              permanent: true,
              opacity: 0.8
            })
          } else {
            // Update tooltip text
            platform.map.target.marker.setTooltipContent(eta)
          }
        } else {
          // Remove tooltip
          platform.map.target.marker.unbindTooltip()
        }
        // Handle target connection line
        const latLngs = [
          [position.lat, position.lng],
          [target.lat, target.lng]
        ]
        if (platform.map.target.line === null) {
          // Create target connection line
          platform.map.target.line = new L.Polyline(latLngs, {
            opacity: OPACITY_TARGET,
            color: '#ffffff',
            weight: TRACK_WIDTH
          }).addTo(widget.map)
        } else {
          platform.map.target.line.setLatLngs(latLngs)
        }
      } else if (platform.map.target.marker !== null) {
        // Remove target coordinates markers
        widget.map.removeLayer(platform.map.target.marker)
        widget.map.removeLayer(platform.map.target.circle)
        widget.map.removeLayer(platform.map.target.line)
        platform.map.target.marker = null
        platform.map.target.circle = null
        platform.map.target.line = null
      }
    },
    renderPlatformSelection: function (widget, platformId) {
      if (platformId in this.platforms) {
        // If selection already exists: Remove marker first
        if (widget.selection != null) {
          widget.map.removeLayer(widget.selection)
        }
        // Create new marker
        widget.selection = new L.Marker(this.position(platformId), {
          icon: this.createSelectionIcon(widget, platformId),
          offset: [-50, -50],
          zIndexOffset: 2000,
          riseOnHover: true
        })
        widget.selection.on('click', () => {
          // Commit selection to global data model
          widget.select_platform(platformId)
          // Select platform on map
          this.selectPlatform(widget, platformId)
        })
        widget.selection.addTo(widget.map)
      }
    },
    renderRangingTool: function (widget) {
      if (widget.tools.rangingBearing.active &&
        widget.selectedPlatform !== widget.tools.rangingBearing.selectedPlatform) {
        // Selected platform has changed: Remove ranging tool first
        this.removeRangingTool(widget)
        widget.tools.rangingBearing.selectedPlatform = widget.selectedPlatform
      }
      if (widget.tools.rangingBearing.active && widget.selectedPlatform !== 0) {
        // Add lines from selected platform to every other platform
        // and calculate distance and bearing
        const posSelected = this.position(widget.selectedPlatform, true)
        if (!this.compareCoordinates(posSelected, INVALID_COORDINATES)) {
          console.debug('map renderer: updating ranging/bearing tool')
          for (const platformId of widget.campaignSelected.platforms) {
            if (Number(platformId) === widget.selectedPlatform) {
              continue
            }
            const posPlatform = this.position(platformId, true)
            if (!this.compareCoordinates(posPlatform, INVALID_COORDINATES)) {
              const distSurface = widget.getDistance(posSelected, posPlatform)
              // const distanceDepth = 0
              const bearing = widget.getBearing(posSelected, posPlatform)
              let textOrientation = 0
              let arrowLeft = ''
              let arrowRight = ''
              if (posSelected.lng <= posPlatform.lng) {
                arrowLeft = ''
                arrowRight = '\u2B9E'
              } else {
                textOrientation = 180
                arrowLeft = '\u2B9C'
                arrowRight = ''
              }
              // FIXME
              const name = widget.platforms[platformId].description + ' \u00B7 '
              // Build text
              let distance = widget.showDigits(distSurface, 0)
              let distanceUnit = 'm'
              if (distance >= 1000) {
                distance = widget.showDigits(distance / 1000, 2)
                distanceUnit = 'km'
              }
              const rangeText = arrowLeft + ' ' + name + distance + ' ' + distanceUnit + ' \u00B7 ' +
                Math.round(bearing) + '° ' + arrowRight

              const textOptions = {
                offset: 15,
                center: true,
                orientation: textOrientation,
                attributes: {
                  fill: '#007bff',
                  stroke: '#004da1',
                  'stroke-width': 0.1,
                  'font-weight': 'bold',
                  'font-size': '14'
                }
              }
              const latLngs = [[posSelected.lat, posSelected.lng], [posPlatform.lat, posPlatform.lng]]
              let range = {}
              if (platformId in widget.tools.rangingBearing.ranges) {
                range = widget.tools.rangingBearing.ranges[platformId]
                range.setLatLngs(latLngs)
                range.setText(null)
                range.setText(rangeText, textOptions)
              } else {
                range = L.polyline(latLngs, {
                  weight: RANGE_WIDTH,
                  zIndexOffset: 3000,
                  color: '#007bff'
                })
                range.setText(rangeText, textOptions)
                widget.tools.rangingBearing.ranges[platformId] = range
                range.addTo(widget.map)
              }
            }
          }
        }
      } else if (Object.keys(widget.tools.rangingBearing.ranges).length > 0) {
        this.removeRangingTool(widget)
      }
    },
    removeRangingTool: function (widget) {
      console.debug('map renderer: removing ranging tool')
      // Remove lines and markers
      for (const range in widget.tools.rangingBearing.ranges) {
        widget.map.removeLayer(widget.tools.rangingBearing.ranges[range])
        delete widget.tools.rangingBearing.ranges[range]
      }
      for (const marker in widget.tools.rangingBearing.markers) {
        widget.map.removeLayer(widget.tools.rangingBearing.markers[marker])
        delete widget.tools.rangingBearing.markers[marker]
      }
    },
    renderDataMarker: function (widget, marker) {
      if (marker !== null) {
        // const platform = this.platforms[marker.parameter[0]]
        const color = widget.getColormap(marker.parameter[5])[Math.round((marker.data - marker.parameter[3]) /
          (marker.parameter[4] - marker.parameter[3]) * (widget.options.colormapShades - 1))]
        const meta = widget.parameterMetaData(marker.parameter)
        let precision = 0
        if ('num_precision' in meta && Number(meta.num_precision) >= 0) {
          precision = meta.num_precision
        }
        if (widget.dataMarker !== null) {
          // Update location, color and tooltip
          widget.dataMarker.setLatLng({ lat: marker.lat, lng: marker.lng })
          widget.dataMarker.setStyle({ fillColor: color })
          widget.dataMarker.setTooltipContent('<strong>' + widget.showDigits(marker.data, precision) + ' ' + meta.unit + '</strong><br>' +
            moment.unix(marker.timestamp / 1000).format('MMM D YYYY HH:mm'))
        } else {
          // Create new data marker
          console.debug('map renderer: create new data marker')
          widget.dataMarker = new L.CircleMarker({ lat: marker.lat, lng: marker.lng }, {
            fill: true,
            fillColor: color,
            fillOpacity: 1.0,
            stroke: false,
            radius: 8,
            zIndexOffset: 1200,
            tooltipAnchor: [0, 0]
          }).addTo(widget.map)
          // Add tooltip to display data
          widget.dataMarker.bindTooltip('<strong>' + widget.showDigits(marker.data, precision) + ' ' + meta.unit + '</strong><br>' +
              moment.unix(marker.timestamp / 1000).format('MMM D YYYY HH:mm'), {
            className: 'solid-tooltip',
            direction: 'top',
            offset: [0, DATA_MARKER_LABEL_OFFSET],
            permanent: true,
            opacity: 1.0
          })
        }
      } else {
        if (widget.dataMarker !== null) {
          console.debug('map renderer: remove data marker')
          // Remove data marker from map if required
          if (widget.map.hasLayer(widget.dataMarker)) {
            widget.map.removeLayer(widget.dataMarker)
          }
          widget.dataMarker = null
        }
      }
    },
    colorizeTrack: function (widget, parameter) {
      // TODO: Optimize: Additive approach
      // TODO: Use grey or transparent if no data is available for time slot
      if (parameter !== null && parameter.length >= 3 && 'nav' in widget.platforms[Number(parameter[0])].map.tracks) {
        // this.dataMarkers = new Map()
        console.debug('map renderer: colorizing track: ' + parameter)
        const paramMeta = widget.parameter(Number(parameter[0]), Number(parameter[1]), Number(parameter[2]))
        // Get colormap
        let colorMap = 'jet'
        if ('colormap' in paramMeta) {
          colorMap = paramMeta.colormap
        }
        // Get min and max values of selected parameter
        const values = this.updates(Number(parameter[0]), Number(parameter[1]), Number(parameter[2]))
        const min = Math.min.apply(Math, values.map(function (i) {
          return i[1]
        }))
        const max = Math.max.apply(Math, values.map(function (i) {
          return i[1]
        }))
        if (!isNaN(min) && !isNaN(max)) {
          // Save additional info to selected parameter
          widget.selectedParameter[3] = min
          widget.selectedParameter[4] = max
          widget.selectedParameter[5] = colorMap
          // Show selected parameter control
          widget.showParameterViewControl(widget)
          // Get part of track
          const lats = this.updates(Number(parameter[0]), NAVIGATION, 1)
          const colors = []
          if (max > min) {
            // Colorize track
            let sum = 0
            let num = 0
            let color = null
            let valIndex = 0
            for (const pos of lats) {
              // Average values between platform positions
              while (valIndex < values.length && values[valIndex][0] <= pos[0]) {
                sum = sum + values[valIndex][1]
                num++
                valIndex++
              }
              // Calculate new color if values where found
              if (num > 0) {
                // console.log(Math.round(((sum / num) - min) / (max - min) * (widget.options.colormapShades - 1)))
                color = widget.getColormap(colorMap)[Math.round(((sum / num) - min) / (max - min) * (widget.options.colormapShades - 1))]
              // } else {
              //   color = NO_DATA_TRACKCOLOR
              }
              colors.push(color)

              // Reset average calculation
              sum = 0
              num = 0
            }
          } else {
            // Min == max: Select a single color for track
            const color = widget.getColormap(colorMap)[0]
            lats.forEach(pos => {
              colors.push(color)
            })
          }
          // Set colors of polyline
          const platform = widget.platforms[Number(parameter[0])]
          if ('colors' in platform.map.tracks.nav.options) {
            // Update colors
            platform.map.tracks.nav.options.color = NO_DATA_TRACKCOLOR
            platform.map.tracks.nav.options.colors = colors
            platform.map.tracks.nav.redraw()
          } else {
            // Remove default polyline first
            platform.map.tracks.nav.removeFrom(widget.map)
            // Create new polycolor line
            platform.map.tracks.nav = L.polycolor(platform.map.tracks.nav.getLatLngs(), {
              color: NO_DATA_TRACKCOLOR,
              colors: colors,
              weight: TRACK_WIDTH,
              opacity: OPACITY_SELECTED_COLORED
            }).addTo(widget.map)
          }
          platform.map.tracks.nav.bringToFront()
          // If everything worked out, return
          return
        }
      }
      // Hide selected parameter control
      widget.removeParameterViewControl(widget)
      // Replace all platform tracks by default track
      for (const platformId in widget.platforms) {
        if (Object.prototype.hasOwnProperty.call(widget.platforms, platformId)) {
          const platform = widget.platforms[platformId]
          if ('nav' in platform.map.tracks && 'colors' in platform.map.tracks.nav.options) {
            // Remove polycolor line first
            platform.map.tracks.nav.removeFrom(widget.map)
            // Add default polyline
            platform.map.tracks.nav = new WrappedPolyline(platform.map.tracks.nav.getLatLngs(), {
              color: platform.color,
              weight: TRACK_WIDTH,
              opacity: OPACITY_SELECTED
            }).addTo(widget.map)
            platform.map.tracks.nav.bringToFront()
          }
        }
      }
    },
    handlePlatformVisibility: function (widget, platformId) {
      // Handle visibility by removing / adding layers
      if (this.campaignSelected.platforms.includes(Number(platformId)) &&
          !widget.compareCoordinates(this.position(platformId), INVALID_COORDINATES)) {
        this.showPlatform(widget, platformId)
      } else {
        this.hidePlatform(widget, platformId)
      }
    },
    handlePlatformMarkers: function (widget, platformId) {
      if (platformId in this.platforms && this.campaignSelected.platforms.includes(Number(platformId))) {
        if (!this.compareCoordinates(this.position((platformId)), INVALID_COORDINATES)) {
          console.debug('map renderer: handling markers of ' + platformId + ', zoom: ' + widget.map.getZoom())
          const platform = this.platforms[platformId]
          // Rescale and toggle visibility of scheme marker
          const scaleFactor = this.meterInPixels(widget)
          const height = platform.length / scaleFactor
          const width = platform.width / scaleFactor
          // Toogle visibility of markers
          $('#navigatorMap .platform-scheme-' + platformId).css({
            width: width,
            height: height,
            'margin-left': Number(-width / 2) + 'px',
            'margin-top': Number(-height / 2) + 'px',
            display: (widget.map.getZoom() < platform.zoom_switch) ? 'none' : 'block'
          })
          $('#navigatorMap .platform-icon-' + platformId).css({
            display: (widget.map.getZoom() > Number(platform.zoom_switch - 1)) ? 'none' : 'block'
          })
          $('#navigatorMap .platform-ghost-usbl-' + platformId).css({
            display: (widget.map.getZoom() > Number(platform.zoom_switch - 1)) ? 'none' : 'block'
          })
          $('#navigatorMap .heading-icon-' + platformId).css({
            display: (widget.map.getZoom() > Number(platform.zoom_switch - 1)) ? 'none' : 'block'
          })
          // Toggle visibility of tooltips
          $('#navigatorMap .transparent-tooltip-' + platformId).css({
            display: (widget.map.getZoom() > Number(platform.zoom_switch - 1)) ? 'none' : 'block'
          })
          $('#navigatorMap .solid-tooltip-' + platformId).css({
            display: (widget.map.getZoom() < platform.zoom_switch) ? 'none' : 'block'
          })
          // FIXME: Workaround to correct tooltip position
          platform.map.markers.icon.openTooltip()
          if ('ghost_usbl' in platform.map.markers) {
            // platform.map.markers.ghost_usbl.openTooltip()
          }
          if ('ghost_lbl' in platform.map.markers) {
            // platform.map.markers.ghost_lbl.openTooltip()
          }
          // Toggle visibility of track decorators
          // if (widget.map.getZoom() > TRACK_ARROWHEAD_ZOOM_MAX) {
          //   if ('nav' in platform.map.decorators && widget.map.hasLayer(platform.map.decorators.nav)) {
          //     widget.map.removeLayer(platform.map.decorators.nav)
          //   }
          // } else {
          //   // Only add decorator if nav track is available
          //   if ('nav' in platform.map.tracks && 'nav' in platform.map.decorators && !widget.map.hasLayer(platform.map.decorators.nav)) {
          //     widget.map.addLayer(platform.map.decorators.nav)
          //   }
          // }
        }
      }
    },
    showPlatform: function (widget, platformId) {
      console.debug('map renderer: showing platform ' + platformId)
      if (platformId in this.platforms) {
        if (!this.compareCoordinates(this.position((platformId)), INVALID_COORDINATES)) {
          const platform = this.platforms[platformId]
          // Show markers
          for (const markerId in platform.map.markers) {
            if (Object.prototype.hasOwnProperty.call(platform.map.markers, markerId)) {
              const marker = platform.map.markers[markerId]
              if (marker !== null && !widget.map.hasLayer(marker)) {
                marker.addTo(widget.map)
              }
            }
          }
          // Show tracks
          for (const trackId in platform.map.tracks) {
            if (Object.prototype.hasOwnProperty.call(platform.map.tracks, trackId)) {
              const track = platform.map.tracks[trackId]
              if (track !== null && !widget.map.hasLayer(track)) {
                track.addTo(widget.map)
              }
            }
          }
          // Show headings
          for (const headingId in platform.map.headings) {
            if (Object.prototype.hasOwnProperty.call(platform.map.headings, headingId)) {
              const heading = platform.map.headings[headingId]
              if (heading !== null && !widget.map.hasLayer(heading)) {
                heading.addTo(widget.map)
              }
            }
          }
          // // Show track decorators
          // for (const decoratorId in platform.map.decorators) {
          //   if (Object.prototype.hasOwnProperty.call(platform.map.decorators, decoratorId)) {
          //     const decorator = platform.map.decorators[decoratorId]
          //     if (decorator !== null && !widget.map.hasLayer(decorator)) {
          //       decorator.addTo(widget.map)
          //     }
          //   }
          // }
          // TODO: Show targets etc
        }
      }
    },
    hidePlatform: function (widget, platformId) {
      console.debug('map renderer: hiding platform ' + platformId)
      if (platformId in this.platforms) {
        const platform = this.platforms[platformId]
        // Hide markers
        for (const markerId in platform.map.markers) {
          if (Object.prototype.hasOwnProperty.call(platform.map.markers, markerId)) {
            const marker = platform.map.markers[markerId]
            if (marker !== null && widget.map.hasLayer(marker)) {
              marker.removeFrom(widget.map)
            }
          }
        }
        // Hide tracks
        for (const trackId in platform.map.tracks) {
          if (Object.prototype.hasOwnProperty.call(platform.map.tracks, trackId)) {
            const track = platform.map.tracks[trackId]
            if (track !== null && widget.map.hasLayer(track)) {
              track.removeFrom(widget.map)
            }
          }
        }
        // Hide headings
        for (const headingId in platform.map.headings) {
          if (Object.prototype.hasOwnProperty.call(platform.map.headings, headingId)) {
            const heading = platform.map.headings[headingId]
            if (heading !== null && widget.map.hasLayer(heading)) {
              heading.removeFrom(widget.map)
            }
          }
        }
        // Hide track decorators
        // for (const decoratorId in platform.map.decorators) {
        //   if (Object.prototype.hasOwnProperty.call(platform.map.decorators, decoratorId)) {
        //     const decorator = platform.map.decorators[decoratorId]
        //     if (decorator !== null && widget.map.hasLayer(decorator)) {
        //       decorator.removeFrom(widget.map)
        //     }
        //   }
        // }
        // TODO Hide targets etc
        // Hide selection
        if (widget.selectedPlatform === platformId) {
          widget.selection.removeFrom(widget.map)
        }
      }
    },
    centerPlatform: function (widget, platformId) {
      const position = this.position(platformId, true)
      if (!this.compareCoordinates(position, INVALID_COORDINATES)) {
        console.debug('map renderer: centering on platform ' + platformId)
        // let zoomLevel = widget.options.selectionZoom
        // if (widget.map.getZoom() > widget.options.selectionZoom) {
        //   zoomLevel = widget.map.getZoom()
        // }
        widget.options.initialCentered = true // Deactivate first platform selection
        widget.map.panTo(this.position(platformId))
      }
    },
    centerFeedItem: function (widget, feedItemId) {
      if (feedItemId !== null && feedItemId in widget.mediaFeed.channel.items) {
        const position = widget.mediaFeed.channel.items[feedItemId].position
        if (!this.compareCoordinates(position, INVALID_COORDINATES)) {
          console.log('map renderer: fly to feed item ' + feedItemId)
          widget.map.flyTo(position)
        }
      }
    },
    selectPlatform: function (widget, platformId, center = false) {
      if (platformId in this.platforms) {
        // Remove data visualization on tracks
        this.colorizeTrack(widget, null)
        // Center map on platform
        if (center) {
          this.centerPlatform(widget, platformId)
          widget.options.initialCentered = true
        }
        // Create or update map selection marker
        this.renderPlatformSelection(widget, platformId)
        // Change opacity of all platforms
        let opacity = 0
        let weight = WEIGHT_DESELECTED
        // let arrowHeadSize = TRACK_ARROWHEAD_SIZE_DESELECTED
        for (const otherPlatformId in this.platforms) {
          const platform = this.platforms[otherPlatformId]
          if ('nav' in platform.map.tracks &&
            platform.type !== 'transponder' && platform.type !== 'lander' && platform.type !== 'buoy') { // FIXME
            if (Number(otherPlatformId) === platformId) {
              if ('colors' in platform.map.tracks.nav.options) {
                opacity = OPACITY_SELECTED_COLORED
                weight = WEIGHT_SELECTED
                // arrowHeadSize = TRACK_ARROWHEAD_SIZE_SELECTED
              } else {
                opacity = OPACITY_SELECTED
                weight = WEIGHT_SELECTED
                // arrowHeadSize = TRACK_ARROWHEAD_SIZE_SELECTED
              }
            } else {
              opacity = OPACITY_DESELECTED
              weight = WEIGHT_DESELECTED
              // arrowHeadSize = TRACK_ARROWHEAD_SIZE_DESELECTED
            }
            // Update track style
            platform.map.tracks.nav.setStyle({
              opacity: opacity,
              weight: weight
            })
            // Update decorator style
            // if ('nav' in platform.map.decorators) {
            //   platform.map.decorators.nav.setPatterns([
            //     {
            //       repeat: TRACK_ARROWHEAD_REPEAT,
            //       symbol: L.Symbol.arrowHead({
            //         headAngle: TRACK_ARROWHEAD_HEADANGLE,
            //         pixelSize: arrowHeadSize,
            //         pathOptions: {
            //           color: platform.map.tracks.nav.options.color,
            //           opacity: opacity
            //         }
            //       })
            //     }
            //   ])
            // }
          }
        }
      }
      // Render ranging tool if required
      this.renderRangingTool(widget)
    },
    deselectPlatforms: function (widget) {
      // Deselect platform in global data model
      if (this.selectedPlatform !== 0) {
        widget.select_platform(0)
        widget.select_parameter(null)
      }
      // Remove colors from platform track
      this.colorizeTrack(widget, null)
      // If selection on map is currently active: Remove selection marker
      if (widget.selection != null) {
        widget.map.removeLayer(widget.selection)
      }
      for (const platformId in this.platforms) {
        const platform = this.platforms[platformId]
        // Change opacity of platform main track
        if ('nav' in platform.map.tracks) {
          // Update track style
          platform.map.tracks.nav.setStyle({
            opacity: OPACITY_DESELECTED,
            weight: WEIGHT_DESELECTED
          })
        }
        // if ('nav' in platform.map.decorators) {
        //   // Update decorator style
        //   platform.map.decorators.nav.setPatterns([
        //     {
        //       repeat: TRACK_ARROWHEAD_REPEAT,
        //       symbol: L.Symbol.arrowHead({
        //         headAngle: TRACK_ARROWHEAD_HEADANGLE,
        //         pixelSize: TRACK_ARROWHEAD_SIZE_DESELECTED,
        //         pathOptions: {
        //           color: platform.map.tracks.nav.options.color,
        //           opacity: OPACITY_DESELECTED
        //         }
        //       })
        //     }
        //   ])
        // }
      }
      // Render ranging tool if required
      this.renderRangingTool(widget)
    },
    loadMission: function (platformId) { // FIXME: DEBUG!
      if (platformId in this.platforms) {
        const platform = this.platforms[platformId]
        if (platform.type === 'auv-g500') {
          axios.get('/data/overlays/missions/mission_' + platform.id + '.xml')
            .then(response => {
              xml2js.parseString(response.data, (err, result) => {
                if (err) {
                  console.warn('map renderer: could not find and parse mission of platform ' + platform.id)
                } else {
                  const missionSteps = result.mission.mission_step
                  if (missionSteps.length > 0) {
                    const missionLatLngs = []
                    let i = 0
                    for (const step in missionSteps) {
                      const maneuver = missionSteps[step].maneuver[0]
                      switch (maneuver.$.type) {
                        case 'goto':
                        case 'waypoint':
                        case 'park':
                          missionLatLngs.push([maneuver.final_latitude[0], maneuver.final_longitude[0]])
                          break
                        case 'section':
                          if (i === 0) {
                            // If mission starts with section: Consider initial position
                            missionLatLngs.push([maneuver.initial_latitude[0], maneuver.initial_longitude[0]])
                          }
                          missionLatLngs.push([maneuver.final_latitude[0], maneuver.final_longitude[0]])
                          break
                        default:
                      }
                      i = i + 1
                    }
                    platform.map.mission.track = new L.Polyline(missionLatLngs, {
                      color: platform.color,
                      dashArray: [6, 4],
                      opacity: 0.7,
                      weight: TRACK_MISSION_WIDTH
                    })
                    platform.map.mission.track.addTo(this.map)
                    // Mission start marker
                    platform.map.mission.markers.start = new L.Marker(missionLatLngs[0], {
                      title: 'Mission start of ' + platform.description,
                      icon: new L.Icon({
                        iconUrl: MISSION_START_ICON_URL,
                        iconAnchor: [16, 22],
                        popupAnchor: [0, -30]
                      })
                    })
                    platform.map.mission.markers.start.addTo(this.map)
                    // Mission end marker
                    platform.map.mission.markers.end = new L.Marker(missionLatLngs[missionLatLngs.length - 1], {
                      title: 'Mission end of ' + platform.description,
                      icon: new L.Icon({
                        iconUrl: MISSION_END_ICON_URL,
                        iconAnchor: [16, 22],
                        popupAnchor: [0, -30]
                      })
                    })
                    platform.map.mission.markers.end.addTo(this.map)
                  }
                }
              })
            })
            .catch(err => {
              console.error(err)
            })
        }
      }
    }
  }
}
